import ceil from 'lodash/ceil'
import compact from "lodash/compact";
import concat from 'lodash/concat'
import apiCalls from "@/mixins/apiCalls.js";
import { mapActions, mapState } from "vuex";

const APP_ACTION = false

export default {
  mixins: [apiCalls],
  data() {
    return {
      users: null
    }
  },
  computed: {
    ...mapState({
      user: state => state.user.profile,
      accountInfo: state => state.account.accountInfo
    })
  },
  methods: {
    ...mapActions([
        "setAccountUsers",
      ]),
    async fetchUsers() {
      let accauntUsersPages = this.accountInfo.users_amount / 40
      const functionName = "get_users";
      let users = []
      for(let i = 0; i <= (ceil(accauntUsersPages) -1); i++) {
        const reqBody = {
          account_id: this.account.domain_id,
          page: i
        };
        const data = await this.makeApiRequest(APP_ACTION, functionName, reqBody);
        if (data.error_code === 200) {
          users = concat(users, data.data);
         
        }
        users = compact(users)
        this.$store.dispatch("setAccountUsers", users);
      }
    },
   
    async fetchUserEndpoints() {
      const functionName = "get_endpoints";
      const reqBody = {
        endpoint_types: ["Mobile", "Trunk", "Deskphone", "Virtual"],
        domain_user_id: this.user.domain_user_id,
        fake: false,
        page: 0,
      };
      const data = await this.makeApiRequest(APP_ACTION, functionName, reqBody);
      if (data.error_code === 200) {
        this.displayItems = data.data;
        return
      }
    },
    async fetchMobileInfo(endpointId) {
      this.loaded = false;
      const appAction = false;
      const functionName = "get_mobile_info";
      const reqBody = {
        fake: false,
        endpoint_id: endpointId
      };
      const data = await this.makeApiRequest(appAction, functionName, reqBody);
      if (data.error_code === 200) {
        this.loaded = true;
        return data.data
      }
    },
   
  },
};
